import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
var styles = require('./IncomingServerInformation.scss');
var IncomingAccountInformation = /** @class */ (function (_super) {
    tslib_1.__extends(IncomingAccountInformation, _super);
    function IncomingAccountInformation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onFolderSelectionChanged = function (option, evt) {
            var useNewFolder = option.key == 'NewFolder';
            _this.props.onUpdateUseNewFolder(useNewFolder);
        };
        _this.renderUserNamePasswordContent = function () {
            return (_this.props.isBasicAuth && (React.createElement("div", null,
                _this.props.renderUserNameContent && (React.createElement(TextField, { className: styles.textbox, label: strings.options_connected_advanced_altUserNameTextField, onChanged: _this.props.onUpdateUserName })),
                React.createElement(TextField, { className: styles.textbox, label: strings.options_connected_basic_passwordTextField, type: "password", onChanged: _this.props.onUpdatePassword, value: _this.props.password }))));
        };
        _this.renderTargetFolderContent = function () {
            return (_this.props.renderNewFolderContent && (React.createElement(ChoiceGroup, { options: [
                    {
                        key: 'NewFolder',
                        text: strings.options_connected_basic_newFolderOption,
                        checked: _this.props.useNewFolder,
                    },
                    {
                        key: 'ExistingFolder',
                        text: strings.options_connected_basic_existingFolderOption,
                        checked: !_this.props.useNewFolder,
                    },
                ], required: true, label: strings.options_connected_basic_targetOptionLabel, onChanged: _this.onFolderSelectionChanged })));
        };
        return _this;
    }
    IncomingAccountInformation.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(TextField, { className: styles.textbox, label: strings.options_connected_basic_displayNameTextField, onChanged: this.props.onUpdateDisplayName, value: this.props.displayName }),
            React.createElement(TextField, { className: styles.textbox, label: strings.options_connected_basic_emailAddressTextField, onChanged: this.props.onUpdateEmailAddress, disabled: this.props.disableEmailAddress, value: this.props.emailAddress }),
            this.renderUserNamePasswordContent(),
            this.renderTargetFolderContent()));
    };
    IncomingAccountInformation = tslib_1.__decorate([
        observer
    ], IncomingAccountInformation);
    return IncomingAccountInformation;
}(React.Component));
export default IncomingAccountInformation;
//# sourceMappingURL=IncomingAccountInformation.js.map